"use strict";

module.exports = ['$http',
    function ($http) {

        return {
            restrict: 'E',
            scope: {
                form: '=',
                name: '=',
                title: '=',
                model: '=',
                pbreadonly: '=',
                details: '=',
                options: '='
            },
            templateUrl: '/partial/app.directives.instagram_user',
            link: function (scope) {

                function setValidity(error, value = null) {
                    if (scope.form && scope.form[scope.name]) { //make sure there is an form
                        if (value === null) {
                            return scope.form[scope.name].$error[error];
                        } else {
                            scope.form[scope.name].$setValidity(error, value);
                        }
                    }
                }

                function abbreviateFollowers(number, decPlaces) {
                    decPlaces = Math.pow(10,decPlaces);
                    let abbrev = [ "k", "m" ];
                    for (let i=abbrev.length-1; i>=0; i--) {
                        let size = Math.pow(10,(i+1)*3);
                        if(size <= number) {
                            number = Math.round(number*decPlaces/size)/decPlaces;
                            if((number == 1000) && (i < abbrev.length - 1)) {
                                number = 1;
                                i++;
                            }
                            number += abbrev[i];
                            break;
                        }
                    }
                    return number;
                }

                function getInstagramProfile(name) {
                    $http.get('social/instagram/getinfo/' + name).
                    then((response) => {
                        let data = response.data;
                        let user = data.user;
                        if(user === undefined){
                            scope.user = null;
                            setValidity('noUsername', false);
                        } else {
                            if (setValidity('noUsername')) {
                                setValidity('noUsername', true);
                            }
                            scope.user = {};
                            if(user.full_name) {
                                scope.user.name = user.full_name;
                            } else {
                                scope.user.name = name;
                            }
                            scope.user.biography = user.biography;
                            scope.user.url = 'https://instagram.com/' + user.username;
                            scope.user.picture = user.profile_pic_url;
                            scope.user.verified = user.is_verified;
                            scope.user.followers = abbreviateFollowers(user.followed_by.count, 1);
                        }
                    });
                }

                if(scope.model.name) {
                    getInstagramProfile(scope.model.name);
                }

                scope.checkUsername = () => {
                    getInstagramProfile(scope.model.name);
                }
            }
        };
    }
];

